import { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Popover,
  Input,
  Switch,
  List,
  Divider,
  Radio,
  Space,
} from "antd";
import "./VencesAssigning.scss";
import PopoverTitle from "../../common/PopoverTitle";
import { ReactComponent as HelpIcon } from "../../../assets/images/Help.svg";
import InclusionIcon from "../../../assets/images/vence/Inclusion.svg";
import ExclusionIcon from "../../../assets/images/vence/Exclusion.svg";
import ModifiedIcon from "../../../assets/images/vence/modified-state.svg";
import clsx from "clsx";
import { SearchOutlined, FolderFilled, WarningFilled } from "@ant-design/icons";
import moment from "moment";

function VencesAssigning(props) {
  const [showHelp, setShowHelp] = useState(true);
  const [currentSection, setCurrentSection] = useState("Home");
  const { assignVenceToHerdModal, setCurrentStep, currentStepDetails } = props;
  const [turnOFFDateRadio, setTurnOFFDateRadio] = useState("after-days");
  const [venceDetailsOfTopOfPaddock, setVenceDetailsOfTopOfPaddock] = useState({
    label: "Top of Paddock",
    key: "top-of-paddock",
    turnONDate: "",
    turnOFFDate: "",
    daysDiff: 1,
  });
  const [venceDetailsOfMiddleOfPaddock, setVenceDetailsOfMiddleOfPaddock] =
    useState({
      label: "Middle of Paddock",
      key: "middle-of-paddock",
      turnONDate: "",
      turnOFFDate: "",
      daysDiff: 1,
    });
  const [
    venceDetailsOfExclusionForLupine,
    setVenceDetailsOfExclusionForLupine,
  ] = useState({
    label: "Exclusion for Lupine",
    key: "exclusion-for-lupine",
    turnONDate: "",
    turnOFFDate: "",
    daysDiff: 1,
  });
  const [venceAssignStep5Popover, setVenceAssignStep5Popover] = useState(false);
  const [venceAssignStep6Popover, setVenceAssignStep6Popover] = useState(false);
  const [venceAssignStep7Popover, setVenceAssignStep7Popover] = useState(false);
  const [venceAssignStep8Popover, setVenceAssignStep8Popover] = useState(false);
  const [venceAssignStep9Popover, setVenceAssignStep9Popover] = useState(false);
  const [venceAssignStep11Popover, setVenceAssignStep11Popover] =
    useState(false);
  const [venceAssignStep12Popover, setVenceAssignStep12Popover] =
    useState(false);
  const [venceAssignStep13Popover, setVenceAssignStep13Popover] =
    useState(false);
  const [venceAssignStep14Popover, setVenceAssignStep14Popover] =
    useState(false);
  const [venceAssignStep18Popover, setVenceAssignStep18Popover] =
    useState(false);
  const [venceAssignStep20Popover, setVenceAssignStep20Popover] =
    useState(false);
  const [venceAssignStep21Popover, setVenceAssignStep21Popover] =
    useState(false);

  useEffect(() => {
    if (currentStepDetails.step) {
      currentStepDetails.popoverComponents?.forEach((popoverComponent) => {
        functionsWithRefs[popoverComponent] &&
          functionsWithRefs[popoverComponent](true);
      });

      // Update the current section
      if (currentStepDetails.currentSection)
        setCurrentSection(currentStepDetails.currentSection);

      // Reset the vence details once user is going to previous step
      if (currentStepDetails.clearVenceDetails) {
        functionsWithRefs[currentStepDetails.clearVenceDetails] &&
          functionsWithRefs[currentStepDetails.clearVenceDetails](
            (prevState) => ({
              ...prevState,
              turnONDate: "",
              turnOFFDate: "",
              daysDiff: 1,
            })
          );
      }
    }
    return () => {
      currentStepDetails.popoverComponents?.forEach((popoverComponent) => {
        functionsWithRefs[popoverComponent] &&
          functionsWithRefs[popoverComponent](false);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStepDetails.step]);

  const assignVenceToHerdModalTitle = (
    <div className="header">
      <div className="title">Assign Vence to Herd</div>
      <Button
        className="canel-button"
        style={{ marginLeft: "auto" }}
        type="link"
      >
        Cancel
      </Button>
      {/* <Button className="save-button" onClick={() => {}}>
        Save
      </Button> */}
      <Button type="text" icon={<HelpIcon className="help-icon" />} />
    </div>
  );

  const toggleSwitch = () => {
    setShowHelp(!showHelp);
  };

  const assignVenceToHerdModalFooter = (
    <div
      id="assign-vence-to-herd-modal-footer"
      className={clsx("assign-vence-to-herd-modal-footer", {
        "overlay-element-assign-vence":
          currentStepDetails.overlayElementsId?.includes(
            "assign-vence-to-herd-modal-footer"
          ),
      })}
    >
      <div className="d-flex" style={{ alignItems: "center" }}>
        {currentSection !== "Home" && (
          <>
            <span style={{ marginRight: "10px" }}>Show Help</span>
            <Switch
              defaultChecked
              onChange={toggleSwitch}
              checked={showHelp}
              disabled
            />
          </>
        )}
      </div>
      <div
        id="footer-controls"
        className={clsx({
          "overlay-element-assign-vence":
            currentStepDetails.overlayElementsId?.includes("footer-controls"),
        })}
        style={{ padding: "2px", backgroundColor: "white" }}
      >
        {currentSection !== "Home" && (
          <Button className="back-button">BACK</Button>
        )}
        {currentSection === "VenceAssignmentsForHerd" ||
        currentSection === "VenceAssignmentsForHerdEdit" ? (
          <Button
            type="primary"
            style={{ background: "#80c342" }}
            onClick={() => setCurrentStep((step) => step + 1)}
          >
            SAVE
          </Button>
        ) : (
          <Popover
            title={PopoverTitle}
            content={
              <div>
                <p>
                  Click <b>NEXT.</b>
                </p>
              </div>
            }
            placement="topRight"
            trigger="hover"
            visible={venceAssignStep7Popover}
          >
            <Button
              style={{
                background: "#474342",
                color: "white",
                borderColor: "#474342",
              }}
              onClick={() => {
                // setCurrentSection("VenceAssignmentsForHerdEdit");
                setCurrentStep((step) => step + 1);
              }}
            >
              NEXT
            </Button>
          </Popover>
        )}
      </div>
    </div>
  );

  const contentOfShowHelp = () => {
    switch (currentSection) {
      case "Home":
        return (
          <>
            <p>
              Hey, This is Todd! I'll be guiding you through the vence
              assignment process.
            </p>
            <p>
              In Herd Manager,{" "}
              <b>vences are assigned to herds, not the other way around.</b>{" "}
              This allows for some powerful stuff as we'll see later on.
            </p>
            <p>
              When assigning vences, none of the collars will be updated with
              new assignments until you go through this setup process and click
              SAVE.
            </p>
            <p>
              Also, don't be afraid to play around. You can always go back or
              click <b>CANCEL</b> to cancel any changes.
            </p>
          </>
        );
      case "SelectHerd":
        return (
          <>
            <p>First select the herd you want to affect with vences.</p>
            <p>
              Currently, if you want to assign the same vence to multiple herds,
              you'll need to do one herd at a time.
            </p>
          </>
        );
      case "VenceAssignmentsForHerd":
        return (
          <>
            <p>
              To control your cattle, vences are applied to a herd. This lets
              you{" "}
              <b>
                create advanced pressure controls on a herd to push them toward
                or away from whatever you want.
              </b>{" "}
              Just remember that the more heavy handed the control, the more
              it'll drain the batteries.
            </p>
            <p>
              Collars can be assigned up to 16 vences or vence configurations
            </p>
          </>
        );
      case "SelectVence":
        return (
          <>
            <p>
              Select the vence you want to assign to My Herd, and click{" "}
              <b>NEXT</b>.
            </p>
          </>
        );
      case "OnAndOffDates":
        return (
          <>
            <p>Every vence has to be assigned with both on and off dates.</p>
            <p>
              Set the times you'd like this vence to turn on and off and click{" "}
              <b>NEXT</b>.
            </p>
          </>
        );
      case "VenceAssignmentsForHerdEdit":
        return (
          <>
            <p>
              Add vences or configurations (up to 16) and when you are happy
              with all the assignments, click <b>SAVE</b> at the bottom.
            </p>
            <p>
              <b>
                Remember, once you click SAVE the collars don't update
                instantly.
              </b>{" "}
              It can take up to 24 hours for all collars to download their new
              vence assignments.
            </p>
          </>
        );
      default:
        return (
          <>
            <p>
              Hey, This is Todd! I'll be guiding you through the vence
              assignment process.
            </p>
            <p>
              In Herd Manager,{" "}
              <b>vences are assigned to herds, not the other way around.</b>{" "}
              This allows for some powerful stuff as we'll see later on.
            </p>
            <p>
              When assigning vences, none of the collars will be updated with
              new assignments until you go through this setup process and click
              SAVE.
            </p>
            <p>
              Also, don't be afraid to play around. You can always go back or
              click <b>CANCEL</b> to cancel any changes.
            </p>
          </>
        );
    }
  };

  const renderSelectHerd = () => {
    return (
      <div className="select-herd">
        <div className="title">Select Herd</div>
        <div className="search">
          <Input
            placeholder="Search..."
            style={{ backgroundColor: "#eee" }}
            prefix={<SearchOutlined style={{ fontSize: "22px" }} />}
          />
        </div>
        <div className="list">
          <div className="folder">
            <FolderFilled className="folder-icon" />
            <div className="folder-label">Archive</div>
          </div>
          <Divider style={{ margin: "0" }} />
          <div
            className="folder"
            onClick={(e) => e.target?.classList?.toggle("highlight")}
          >
            <div className="count">42</div>
            <div className="folder-label">First Herd</div>
          </div>
          <Divider style={{ margin: "0" }} />
          <Popover
            title={PopoverTitle}
            content={contentOfVenceAssignStep6Popover}
            placement="leftTop"
            trigger="hover"
            visible={venceAssignStep6Popover}
          >
            <div
              className={clsx(
                "folder",
                {
                  highlight:
                    currentStepDetails?.highlightSection?.includes(
                      "my-herd-item"
                    ),
                },
                {
                  "overlay-element-assign-vence":
                    currentStepDetails.overlayElementsId?.includes(
                      "my-herd-item"
                    ),
                }
              )}
              id="my-herd-item"
              onClick={() => {
                setCurrentStep((step) => step + 1);
              }}
            >
              <div className="count">10</div>
              <div className="folder-label">My Herd</div>
            </div>
          </Popover>
          <Divider style={{ margin: "0" }} />
        </div>
      </div>
    );
  };

  const renderVenceAssignmentsForHerd = () => {
    return (
      <div
        className={clsx("vence-assignments-for-herd", {
          "overlay-element-assign-vence":
            currentStepDetails.overlayElementsId?.includes(
              "vence-assignments-for-herd"
            ),
        })}
      >
        <div className="title">Vence Assignments for My Herd</div>
        <div className="vence-table">
          <div className="vence-table-header">
            <div
              className="table-header"
              style={{
                width: "40%",
                borderRight: "1px solid #e2e1e1",
                textAlign: "left",
              }}
            >
              Vence
            </div>
            <div
              className="table-header"
              style={{ width: "25%", borderRight: "1px solid #e2e1e1" }}
            >
              From
            </div>
            <div
              className="table-header"
              style={{ width: "25%", borderRight: "1px solid #e2e1e1" }}
            >
              To
            </div>
            <div className="table-header" style={{ width: "10%" }}>
              State
            </div>
          </div>
        </div>
        <div className="vence-assignment-controls">
          <div style={{ marginRight: "20px" }}>No vences assigned yet</div>
          <Popover
            title={PopoverTitle}
            content={contentOfVenceAssignStep8Popover}
            placement="bottomRight"
            trigger="hover"
            visible={venceAssignStep8Popover}
          >
            <Button
              type="primary"
              style={{ backgroundColor: "#80c342", textTransform: "uppercase" }}
              onClick={() => setCurrentStep((step) => step + 1)}
            >
              Add Vence
            </Button>
          </Popover>
        </div>
      </div>
    );
  };

  const renderSelectVence = () => {
    return (
      <div className="select-herd">
        <div className="title">Select Vence</div>
        <div className="search">
          <Input
            placeholder="Search..."
            style={{ backgroundColor: "#eee" }}
            prefix={<SearchOutlined style={{ fontSize: "22px" }} />}
          />
        </div>
        <div className="list">
          <div className="folder">
            <FolderFilled className="folder-icon" />
            <div className="folder-label">Archive</div>
          </div>
          <Divider style={{ margin: "0" }} />
          <Popover
            title={PopoverTitle}
            content={contentOfVenceAssignStep9Popover}
            placement="left"
            trigger="hover"
            visible={venceAssignStep9Popover}
          >
            <div
              onClick={() => {
                setCurrentStep((step) => step + 1);
              }}
              className={clsx(
                "folder",
                {
                  highlight: currentStepDetails?.highlightSection?.includes(
                    "top-of-paddock-item"
                  ),
                },
                {
                  "overlay-element-assign-vence":
                    currentStepDetails.overlayElementsId?.includes(
                      "top-of-paddock-item"
                    ),
                }
              )}
              id="top-of-paddock-item"
            >
              <img
                className="folder-icon"
                src={InclusionIcon}
                alt="Inclusion Icon"
              />
              <div className="folder-label">Top of Paddock</div>
            </div>
          </Popover>
          <Divider style={{ margin: "0" }} />
          <Popover
            title={PopoverTitle}
            content={contentOfVenceAssignStep14Popover}
            placement="left"
            trigger="hover"
            visible={venceAssignStep14Popover}
          >
            <div
              onClick={() => {
                setCurrentStep((step) => step + 1);
              }}
              className={clsx(
                "folder",
                {
                  highlight: currentStepDetails?.highlightSection?.includes(
                    "middle-of-paddock-item"
                  ),
                },
                {
                  "overlay-element-assign-vence":
                    currentStepDetails.overlayElementsId?.includes(
                      "middle-of-paddock-item"
                    ),
                }
              )}
              id="middle-of-paddock-item"
            >
              <img
                className="folder-icon"
                src={InclusionIcon}
                alt="Inclusion Icon"
              />
              <div className="folder-label">Middle of Paddock</div>
            </div>
          </Popover>
          <Divider style={{ margin: "0" }} />
          <Popover
            title={PopoverTitle}
            content={contentOfVenceAssignStep18Popover}
            placement="left"
            trigger="hover"
            visible={venceAssignStep18Popover}
          >
            <div
              onClick={() => {
                setCurrentStep((step) => step + 1);
              }}
              className={clsx(
                "folder",
                {
                  highlight: currentStepDetails?.highlightSection?.includes(
                    "exclusion-for-lupine-item"
                  ),
                },
                {
                  "overlay-element-assign-vence":
                    currentStepDetails.overlayElementsId?.includes(
                      "exclusion-for-lupine-item"
                    ),
                }
              )}
              id="exclusion-for-lupine-item"
            >
              <img
                className="folder-icon"
                src={ExclusionIcon}
                alt="Exclusion Icon"
              />
              <div className="folder-label">Exclusion for Lupine</div>
            </div>
          </Popover>
          <Divider style={{ margin: "0" }} />
        </div>
      </div>
    );
  };

  const renderOnAndOffDates = () => {
    return (
      <div
        className={clsx("on-off-dates", {
          "overlay-element-assign-vence":
            currentStepDetails.overlayElementsId?.includes("on-off-dates"),
        })}
      >
        <div className="title">
          Set On/Off Dates for{" "}
          {hookStateRefs[currentStepDetails.selectedVence]?.label}
        </div>
        <div className="vence-dates">
          <div
            className={clsx("date-section", {
              "overlay-element-assign-vence":
                currentStepDetails.overlayElementsId?.includes(
                  "turnON-date-section"
                ),
            })}
          >
            <div className="date-section-title">Turn ON</div>
            <Popover
              title={PopoverTitle}
              content={renderContentOfTurnONDatePopover()}
              placement="left"
              trigger="hover"
              visible={venceAssignStep11Popover}
            >
              <div className="date-section-form">
                <input
                  className="date-input"
                  type="datetime-local"
                  id="turnON"
                  name="turnON"
                  onChange={turnONDateChange}
                  value={
                    hookStateRefs[currentStepDetails.selectedVence]?.turnONDate
                  }
                />
              </div>
            </Popover>
          </div>
          <div className="date-section">
            <div className="date-section-title">Turn OFF</div>
            <div className="date-section-form">
              <Popover
                title={PopoverTitle}
                content={contentOfVenceAssignStep12Popover}
                placement="left"
                trigger="hover"
                visible={venceAssignStep12Popover}
              >
                <div className="date-after-number">
                  <input
                    value="after-days"
                    type="radio"
                    name="turnOFF-date"
                    defaultChecked={true}
                    onChange={() => setTurnOFFDateRadio("after-days")}
                  />
                  <div>After</div>
                  <input
                    type="number"
                    min={1}
                    // defaultValue={1}
                    style={{
                      width: "50px",
                      height: "23px",
                      border: "1px solid black",
                      borderRadius: "3px",
                      margin: "0px 5px",
                    }}
                    onChange={daysDiffChange}
                    value={
                      hookStateRefs[currentStepDetails.selectedVence]?.daysDiff
                    }
                  />
                  <div>days</div>
                </div>
              </Popover>
              <div
                className="d-flex"
                style={{
                  flexFlow: "wrap",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                <input
                  value="specific-date"
                  type="radio"
                  name="turnOFF-date"
                  onChange={() => setTurnOFFDateRadio("specific-date")}
                />
                <div style={{ margin: "0 8px" }}>On Specific Date:</div>
                <Popover
                  title={PopoverTitle}
                  content={contentOfVenceAssignStep20Popover1}
                  placement="bottom"
                  trigger="hover"
                  visible={venceAssignStep20Popover}
                >
                  <input
                    type="datetime-local"
                    id="turnOFF"
                    name="turnOFF"
                    className="date-input"
                    disabled={turnOFFDateRadio === "after-days"}
                    style={{ marginLeft: "20px" }}
                    onChange={turnOFFDateChange}
                    value={
                      hookStateRefs[currentStepDetails.selectedVence]
                        ?.turnOFFDate
                    }
                  />
                </Popover>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderVenceAssignmentsForHerdEdit = () => {
    return (
      <div
        className="vence-assignments-for-herd d-flex"
        style={{ flexDirection: "column", height: "100%" }}
      >
        <div className="title">Vence Assignments for My Herd</div>
        <div className="vence-table">
          <div className="vence-table-header">
            <div
              className="table-header"
              style={{
                width: "40%",
                borderRight: "1px solid #e2e1e1",
                textAlign: "left",
              }}
            >
              Vence
            </div>
            <div
              className="table-header"
              style={{ width: "25%", borderRight: "1px solid #e2e1e1" }}
            >
              From
            </div>
            <div
              className="table-header"
              style={{ width: "25%", borderRight: "1px solid #e2e1e1" }}
            >
              To
            </div>
            <div className="table-header" style={{ width: "10%" }}>
              State
            </div>
          </div>
          {venceDetailsOfTopOfPaddock.turnONDate && (
            <div className="vence-table-row">
              <div
                className="table-row-cell"
                style={{
                  width: "40%",
                  borderRight: "1px solid #e2e1e1",
                  textAlign: "left",
                }}
              >
                <img
                  src={InclusionIcon}
                  alt="Inclusion Icon"
                  style={{ width: "16px", height: "16px", marginRight: "5px" }}
                />
                Top of Paddock
              </div>
              <div
                className="table-row-cell"
                style={{ width: "25%", borderRight: "1px solid #e2e1e1" }}
              >
                {moment(venceDetailsOfTopOfPaddock.turnONDate).format(
                  "MM/DD/YY, h:mm A"
                )}
              </div>
              <div
                className="table-row-cell"
                style={{ width: "25%", borderRight: "1px solid #e2e1e1" }}
              >
                {moment(venceDetailsOfTopOfPaddock.turnOFFDate).format(
                  "MM/DD/YY, h:mm A"
                )}
              </div>
              <div className="table-row-cell" style={{ width: "10%" }}>
                <img
                  src={ModifiedIcon}
                  alt="Modified Icon"
                  style={{ width: "20px", height: "20px" }}
                />
              </div>
            </div>
          )}
          {venceDetailsOfMiddleOfPaddock.turnONDate && (
            <div className="vence-table-row">
              <div
                className="table-row-cell"
                style={{
                  width: "40%",
                  borderRight: "1px solid #e2e1e1",
                  textAlign: "left",
                }}
              >
                <img
                  src={InclusionIcon}
                  alt="Inclusion Icon"
                  style={{ width: "16px", height: "16px", marginRight: "5px" }}
                />
                Middle of Paddock
              </div>
              <div
                className="table-row-cell"
                style={{ width: "25%", borderRight: "1px solid #e2e1e1" }}
              >
                {moment(venceDetailsOfMiddleOfPaddock.turnONDate).format(
                  "MM/DD/YY, h:mm A"
                )}
              </div>
              <div
                className="table-row-cell"
                style={{ width: "25%", borderRight: "1px solid #e2e1e1" }}
              >
                {moment(venceDetailsOfMiddleOfPaddock.turnOFFDate).format(
                  "MM/DD/YY, h:mm A"
                )}
              </div>
              <div className="table-row-cell" style={{ width: "10%" }}>
                <img
                  src={ModifiedIcon}
                  alt="Modified Icon"
                  style={{ width: "20px", height: "20px" }}
                />
              </div>
            </div>
          )}
          {venceDetailsOfExclusionForLupine.turnONDate && (
            <div className="vence-table-row">
              <div
                className="table-row-cell"
                style={{
                  width: "40%",
                  borderRight: "1px solid #e2e1e1",
                  textAlign: "left",
                }}
              >
                <img
                  src={ExclusionIcon}
                  alt="Exclusion Icon"
                  style={{ width: "16px", height: "16px", marginRight: "5px" }}
                />
                Exclusion for Lupine
              </div>
              <div
                className="table-row-cell"
                style={{ width: "25%", borderRight: "1px solid #e2e1e1" }}
              >
                {moment(venceDetailsOfExclusionForLupine.turnONDate).format(
                  "MM/DD/YY, h:mm A"
                )}
              </div>
              <div
                className="table-row-cell"
                style={{ width: "25%", borderRight: "1px solid #e2e1e1" }}
              >
                {moment(venceDetailsOfExclusionForLupine.turnOFFDate).format(
                  "MM/DD/YY, h:mm A"
                )}
              </div>
              <div className="table-row-cell" style={{ width: "10%" }}>
                <img
                  src={ModifiedIcon}
                  alt="Modified Icon"
                  style={{ width: "20px", height: "20px" }}
                />
              </div>
            </div>
          )}
        </div>
        <Popover
          title={PopoverTitle}
          content={contentOfVenceAssignStep21Popover}
          placement="left"
          trigger="hover"
          visible={venceAssignStep21Popover}
        >
          <div className="vence-assignment-controls">
            <Popover
              title={PopoverTitle}
              content={
                currentStepDetails.step === 13
                  ? contentOfVenceAssignStep13Popover
                  : contentOfVenceAssignStep17Popover
              }
              placement="leftTop"
              trigger="hover"
              visible={venceAssignStep13Popover}
            >
              <Button
                type="primary"
                style={{
                  backgroundColor: "#80c342",
                  textTransform: "uppercase",
                  marginRight: "10px",
                }}
                onClick={() => setCurrentStep((step) => step + 1)}
              >
                Add Vence
              </Button>
            </Popover>
            <Button
              style={{
                backgroundColor: "#474342",
                textTransform: "uppercase",
                marginRight: "10px",
                color: "#fff",
                borderColor: "#474342",
              }}
            >
              Remove...
            </Button>
            <Button
              style={{
                backgroundColor: "#474342",
                textTransform: "uppercase",
                color: "#fff",
                borderColor: "#474342",
              }}
            >
              Edit...
            </Button>
          </div>
        </Popover>
        <div className="vence-assignment-warning">
          <WarningFilled
            style={{ fontSize: "40px", color: "#ffd000", paddingRight: "20px" }}
          />
          <div style={{ fontSize: "12px" }}>
            REMEMBER: <b>Collars do not receive vence data immediately</b>. Once
            you change assignments and save vences for a herd, it may take
            several hours for all collars in a herd to update with new vence
            information.
          </div>
        </div>
      </div>
    );
  };

  const renderMainSection = () => {
    switch (currentSection) {
      case "Home":
        return "";
      case "SelectHerd":
        return renderSelectHerd();
      case "VenceAssignmentsForHerd":
        return renderVenceAssignmentsForHerd();
      case "SelectVence":
        return renderSelectVence();
      case "OnAndOffDates":
        return renderOnAndOffDates();
      case "VenceAssignmentsForHerdEdit":
        return renderVenceAssignmentsForHerdEdit();
      default:
        return "";
    }
  };

  const hookStateRefs = {
    venceDetailsOfTopOfPaddock: venceDetailsOfTopOfPaddock,
    venceDetailsOfMiddleOfPaddock: venceDetailsOfMiddleOfPaddock,
    venceDetailsOfExclusionForLupine: venceDetailsOfExclusionForLupine,
  };

  const functionsWithRefs = {
    venceDetailsOfTopOfPaddock: setVenceDetailsOfTopOfPaddock,
    venceDetailsOfMiddleOfPaddock: setVenceDetailsOfMiddleOfPaddock,
    venceDetailsOfExclusionForLupine: setVenceDetailsOfExclusionForLupine,

    venceAssignStep5Popover: setVenceAssignStep5Popover,
    venceAssignStep6Popover: setVenceAssignStep6Popover,
    venceAssignStep7Popover: setVenceAssignStep7Popover,
    venceAssignStep8Popover: setVenceAssignStep8Popover,
    venceAssignStep9Popover: setVenceAssignStep9Popover,
    venceAssignStep11Popover: setVenceAssignStep11Popover,
    venceAssignStep12Popover: setVenceAssignStep12Popover,
    venceAssignStep13Popover: setVenceAssignStep13Popover,
    venceAssignStep14Popover: setVenceAssignStep14Popover,
    venceAssignStep18Popover: setVenceAssignStep18Popover,
    venceAssignStep20Popover: setVenceAssignStep20Popover,
    venceAssignStep21Popover: setVenceAssignStep21Popover,
  };

  const turnONDateChange = (e) => {
    let turnONDate = e.target.value;
    let setVenceDetails = functionsWithRefs[currentStepDetails.selectedVence];
    let venceDetails = hookStateRefs[currentStepDetails.selectedVence];
    if (setVenceDetails && venceDetails) {
      let numberOfDays = venceDetails.daysDiff || 1;
      let turnOFFDate = new Date(turnONDate).setDate(
        new Date(turnONDate).getDate() + numberOfDays
      );
      turnOFFDate = moment(turnOFFDate).format("YYYY-MM-DDTHH:mm");
      setVenceDetails((prevState) => ({
        ...prevState,
        turnONDate: turnONDate,
        turnOFFDate: turnOFFDate,
      }));
    }
  };

  const daysDiffChange = (e) => {
    let daysDiff = e.target.valueAsNumber || e.target.value;
    let setVenceDetails = functionsWithRefs[currentStepDetails.selectedVence];
    let venceDetails = hookStateRefs[currentStepDetails.selectedVence];
    if (setVenceDetails && venceDetails) {
      let turnOFFDate = new Date(venceDetails.turnONDate).setDate(
        new Date(venceDetails.turnONDate).getDate() + daysDiff
      );
      turnOFFDate = moment(turnOFFDate).format("YYYY-MM-DDTHH:mm");
      setVenceDetails((prevState) => ({
        ...prevState,
        daysDiff: daysDiff,
        turnOFFDate: turnOFFDate,
      }));
    }
  };

  const turnOFFDateChange = (e) => {
    let turnOFFDate = e.target.value;
    let setVenceDetails = functionsWithRefs[currentStepDetails.selectedVence];
    let venceDetails = hookStateRefs[currentStepDetails.selectedVence];
    if (setVenceDetails && venceDetails) {
      setVenceDetails((prevState) => ({
        ...prevState,
        turnOFFDate: turnOFFDate,
      }));
    }
  };

  const contentOfShowHelpPopover = (
    <div>
      <p>
        This is the Vence Assignment Wizard. It’ll help you each time you assign
        vences.
      </p>
      <p>
        Go ahead and click <b>NEXT.</b>
      </p>
    </div>
  );

  const contentOfVenceAssignStep6Popover = (
    <div>
      <p>
        Select <b>My Herd</b> from the list of herds.
      </p>
    </div>
  );

  const contentOfVenceAssignStep8Popover = (
    <div>
      <p>
        My Herd currently has no vences assigned to the collars. This means the
        collars will broadcast their status and GPS locations, but they won’t be
        affected by any vences.
      </p>
      <p>
        Let’s add the first vence by clicking <b>ADD.</b>
      </p>
    </div>
  );

  const contentOfVenceAssignStep9Popover = (
    <div>
      <p>
        Vence icons with checks show inclusion vences and X icons show
        exclusions.
      </p>
      <p>
        Let’s start with assigning the vence that’ll keep the cattle in the top
        of the pasture.
      </p>
    </div>
  );

  const renderContentOfTurnONDatePopover = () => {
    switch (currentStepDetails.step) {
      case 11:
        return contentOfVenceAssignStep11Popover;
      case 16:
        return contentOfVenceAssignStep16Popover;
      case 20:
        return contentOfVenceAssignStep20Popover;
      default:
        return contentOfVenceAssignStep11Popover;
    }
  };

  const contentOfVenceAssignStep11Popover = (
    <div>
      <p>
        Now that we know what vence we’re assigning, we need to let the collars
        know when that vence is supposed to turn on and off.
      </p>
      <p>
        Select a date for the vence to turn <b>ON.</b>
      </p>
      <div>
        <Button
          type="primary"
          size="middle"
          style={{ left: "80%" }}
          onClick={() => setCurrentStep((step) => step + 1)}
          className="tutorial-guide-button"
          disabled={venceDetailsOfTopOfPaddock.turnONDate === ""}
        >
          Next
        </Button>
      </div>
    </div>
  );

  const contentOfVenceAssignStep12Popover = (
    <div>
      <p>Let’s set the vence to turn off after 3 days.</p>
      <p>
        When you’re finished, click <b>NEXT.</b>
      </p>
    </div>
  );

  const contentOfVenceAssignStep13Popover = (
    <div>
      <p>
        Great! We’ve got one vence set up for My Herd. But remember it won’t be
        scheduled in the collars until you click Save.
      </p>
      <p>
        Right now, however, let’s set up the other two vences. Click{" "}
        <b>ADD VENCE.</b>
      </p>
    </div>
  );

  const contentOfVenceAssignStep14Popover = (
    <div>
      <p>This time let’s schedule the middle of the paddock.</p>
      <p>
        To make this work, we’re going to have to both turn off the first vence
        (which is keeping the cattle in the top part of the paddock) and turn on
        the second vence (which will keep the cattle from going to the lowest
        part of the pasture).
      </p>
      <p>
        <b>We’ve already set the turn off date for the Top of the Paddock</b> so
        we’ll just need to match that date when setting up the turn on time for
        the middle paddock.
      </p>
      <p>
        Select <b>Middle of the Paddock</b> and click <b>NEXT.</b>
      </p>
    </div>
  );

  const contentOfVenceAssignStep16Popover = (
    <div>
      <p>
        Let’s turn on the Middle of the Paddock vence at{" "}
        <b>
          {moment(venceDetailsOfTopOfPaddock.turnOFFDate).format(
            "MM/DD/YY, h:mm A"
          )}
          ,
        </b>{" "}
        which was when we specified the Top of the Paddock vence to turn off.
      </p>
      <p>
        Then, set the vence to <b>turn off after 4 days.</b>
      </p>
      <p>
        When you’re finished, click <b>NEXT.</b>
      </p>
    </div>
  );

  const contentOfVenceAssignStep17Popover = (
    <div>
      <p>
        Great! We’ve set up two vences which have defined three separate grazing
        areas.
      </p>
      <p>
        One last thing: remember that lupine? We need to set the exclusion vence
        to keep the herd out of it across all three scheduled grazes.
      </p>
      <p>
        Click <b>ADD VENCE.</b>
      </p>
    </div>
  );

  const contentOfVenceAssignStep18Popover = (
    <div>
      <p>This time let’s schedule the exclusion vence.</p>
      <p>
        Select <b>Exlusion for Lupine</b> and click <b>NEXT.</b>
      </p>
    </div>
  );

  const contentOfVenceAssignStep20Popover = (
    <div>
      <p>
        Remember that we want the Exclusion for Lupine vence to be{" "}
        <b>active the entire time we have cattle grazing in this pasture</b>. So
        it needs to be active on or before{" "}
        <b>
          {" "}
          {moment(venceDetailsOfTopOfPaddock.turnONDate).format(
            "MM/DD/YY, h:mm A"
          )}
          .
        </b>
      </p>
    </div>
  );

  const contentOfVenceAssignStep20Popover1 = (
    <div>
      <p>
        We know that we’ve planned cattle to be grazing in this paddock until{" "}
        <b>
          {moment(venceDetailsOfMiddleOfPaddock.turnOFFDate).format(
            "MM/DD/YY, h:mm A"
          )}
        </b>{" "}
        so let’s choose a specific date to turn off this vence.{" "}
        <b>
          Set the turn off time to some time after{" "}
          {moment(venceDetailsOfMiddleOfPaddock.turnOFFDate).format(
            "MM/DD/YY, h:mm A"
          )}
          .
        </b>
      </p>
      <p>
        When you’re done, click <b>NEXT.</b>
      </p>
    </div>
  );

  const contentOfVenceAssignStep21Popover = (
    <div>
      <p>
        Awesome! We’ve set up all three vences we’ll need to successfully graze
        our cattle in this pasture.
      </p>
      <p>
        Click <b>SAVE</b> to start the process of updating the collars with
        these new vence assignments.
      </p>
    </div>
  );

  return (
    <>
      <Modal
        visible={assignVenceToHerdModal}
        title={assignVenceToHerdModalTitle}
        width={1024}
        footer={assignVenceToHerdModalFooter}
        closable={false}
        wrapClassName="assign-vence-to-herd-modal-wrap"
        className={clsx("assign-vence-to-herd-modal", {
          "overlay-element-assign-vence":
            currentStepDetails.overlayElementsId?.includes(
              "assign-vence-to-herd-modal"
            ),
        })}
        destroyOnClose={true}
      >
        <div
          className={clsx("body", {
            "overlay-element-assign-vence":
              currentStepDetails.overlayElementsId?.includes(
                "assign-vence-to-herd-body"
              ),
          })}
        >
          <div
            className={clsx("modal-content", {
              "background-picture": currentSection === "Home",
            })}
          >
            {showHelp && (
              <div className="help-section" style={{ width: "30%" }}>
                <div className="help-title">{PopoverTitle}</div>
                <Popover
                  title={PopoverTitle}
                  content={contentOfShowHelpPopover}
                  placement="leftTop"
                  trigger="hover"
                  visible={venceAssignStep5Popover}
                >
                  <div className="help-content">{contentOfShowHelp()}</div>
                </Popover>
              </div>
            )}
            {currentSection !== "Home" && (
              <div
                style={{ width: showHelp ? "70%" : "100%" }}
                className={clsx("main-section", {
                  "overlay-element-assign-vence":
                    currentStepDetails.overlayElementsId?.includes(
                      "assign-vence-to-herd-main-section"
                    ),
                })}
              >
                {renderMainSection()}
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
}

export default VencesAssigning;
